import produce from 'immer';

// eslint-disable-next-line no-unused-vars
import { CareerAndSeasonStatsState } from '../types';
// eslint-disable-next-line no-unused-vars
import { Action } from '../../../../types';
import {
    SET_CAREER_AND_SEASON_STATS,
    SET_NAV_ITEM,
    SET_SORT,
    SET_BENCHMARKING,
    SET_CAREER_AND_SEASON_STATS_REQUEST,
    REMOVE_CAREER_AND_SEASON_STATS_REQUEST,
    SET_DATA_TYPE,
    SET_CAREER_SEASONS_STATS
} from '../actions';
import {
    setNavItem,
    setSort,
    setBenchmarking,
    setDataType,
    setRequest,
    removeRequest
} from '../../shared/reducer';
import {} from './';
import { DATA_TYPE } from '../../../../../../statspro/js/components/common/config/data-type';
import { setCareerAndSeasonStats } from './set-career-and-season-stats';
import { setCareerSeasonsStats } from './set-career-seasons-stats';

/**
 * @type {CareerAndSeasonStatsState}
 */
const initialState = {
    nav: {
        category: 'Key Stats',
        competition: {
            id: null
        },
        season: {
            id: -1
        }
    },
    sort: {
        columnId: null,
        sortDirection: 'descending',
        force: false
    },
    benchmarking: {
        isActive: false
    },
    dataType: {
        type: DATA_TYPE.TOTALS
    },
    requests: [],
    data: {
        season: [],
        yearly: []
    }
};

/**
 * @param {CareerAndSeasonStatsState} state - The Redux state.
 * @param {Action} action - The Redux action.
 * @returns {CareerAndSeasonStatsState} The updated Redux state.
 */
export const careerAndSeasonStatsReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_CAREER_AND_SEASON_STATS:
                setCareerAndSeasonStats(draft, action.payload);
                break;
            case SET_CAREER_SEASONS_STATS:
                setCareerSeasonsStats(draft, action.payload);
                break;
            case SET_CAREER_AND_SEASON_STATS_REQUEST:
                setRequest(draft, action.payload);
                break;
            case REMOVE_CAREER_AND_SEASON_STATS_REQUEST:
                removeRequest(draft, action.payload);
                break;
            case SET_NAV_ITEM:
                setNavItem(draft, action.payload);
                break;
            case SET_SORT:
                setSort(draft, action.payload);
                break;
            case SET_BENCHMARKING:
                setBenchmarking(draft, action.payload);
                break;
            case SET_DATA_TYPE:
                setDataType(draft, action.payload);
                break;
            default:
                draft;
        }
    });
};
